<template>
<div>
  <!-- page wrapper start -->
	<div class="pg-wrapper product-detail-wrapper">
    <app-header>
      <div class="title-bar" slot="header-foot">
        <div class="nav-bar-wrapper">
          <div class="nab-bar-left">
            <button @click="goBack()" class="button is-flex nav-back">
              <img src="@/assets/img/icon-nav-arrow-left.svg" alt="Go Back" />
            </button>
       
             <h1 class="mb0 mt0 product-detail-breadcrumb has-text-dark">
              <span class="has-text-dark">All <i class="fa fa-angle-right" aria-hidden="true"></i> </span>
              <span class="has-text-dark" v-if="productDetail.category"> {{ productDetail.category.name }} <i class="fa fa-angle-right" aria-hidden="true"></i>&nbsp;</span>Product Detail
            </h1>
          </div>
          <div class="nav-bar-right">
          </div>
        </div>
      </div> 

    </app-header>
    
		<main class="content-wrapper pt20 pb20">
      <!-- <div class="container is-fluid is-​fullwidth">
        <div class="columns">
          <div class="column is-12-widescreen is-12-desktop is-12-tablet is-12-mobile">
            <div class="pg-title-block pg-no-border mb-5">
              <div class="is-flex align-items-center">
                <button @click="goBack()" class="button is-flex nav-back fluid-nav-back is-rotated-180 mr20 align-items-center">
                  <img src="@/assets/img/icon-nav-arrow-right.svg" alt="Go Back">
                </button>
                <div class="title-block is-flex flex-1 justify-content-between align-items-center">
                  <h1 class="title mb0 product-detail-breadcrumb">
                    <span>All <i class="fa fa-angle-right" aria-hidden="true"></i> </span>
                    <span v-if="productDetail.category"> {{ productDetail.category.name }} <i class="fa fa-angle-right" aria-hidden="true"></i>&nbsp;</span>Product Detail
                  </h1>
                </div>
              </div>
            </div>
          </div>
         </div>
      </div> -->

      <div class="container is-fluid">
        
        <product-detail-skeleton  v-if="!loaded"/>

        <div class="columns" v-else>          
          <div class="column is-9-widescreen is-9-desktop is-7-tablet is-12-mobile has-background-semi-dark">
     
              <div class="columns justify-content-center">
                <div class="column is-12">

                  <detail v-if="productDetail" :product="{
                    images: productDetail.images,
                    name: productDetail.name,
                    brandName: productDetail.brand ? productDetail.brand.name : '',
                    desc: productDetail.description,
                    variants: selectedLocationVariants(productDetail.variants),
                  }"></detail>

                  <features v-if="productDetail && productDetail.product_family == 'cannabis'" :product="{
                    product_thc_cbd_levels: productDetail.thc_cbd_levels,
                    product_cannabis_attributes: productDetail.cannabis_attributes,
                    productDetail: productDetail,
                  }"></features>

                  <div class="mobile-selected-store is-hidden-tablet pb20">
                    <selected-store :type="'sm'" v-if="loaded" :product="{
                      selected_location_product_variants: selectedLocationVariants(productDetail.variants),
                      product: productDetail,
                    }"></selected-store>
                  </div>

                  <div class="product-info-blocks accordions" v-if="productDetail && productDetail.product_family != 'accessories'">

                    <terpene-profile 
                      v-if="productDetail && productDetail.product_family == 'cannabis'"
                      :terpenes="productDetail.terpenes.length > 0 ? productDetail.terpenes : []">
                    </terpene-profile>

                    <consumption 
                      v-if="productDetail"  
                      :product="{
                        usage_instructions: productDetail.usage_instructions
                      }"> 
                    </consumption>
                  </div>
                </div>
              </div>
           
          </div>

          <div class="column is-3-widescreen is-3-desktop is-5-tablet is-12-mobile is-hidden-mobile"><!--  is-hidden-mobile -->
      
            <!--   selected_location_product_variants: productDetail.variants,-->
            <selected-store :type="'lg'" v-if="loaded && productDetail" :product="{
              selected_location_product_variants: selectedLocationVariants(productDetail.variants),
              product: productDetail,
            }"></selected-store>
          </div>
        </div>

      </div>

		</main>
    <app-footer></app-footer>

    <!-- modals -->
    <!-- <cart-full></cart-full> -->
    <change-store-notice></change-store-notice>
    <select-store></select-store>
    <out-of-stock></out-of-stock>
    <user-not-logged-in-modal></user-not-logged-in-modal>
    
    <mobile-footer-actions v-if="loaded" :variants='selectedLocationVariants(productDetail.variants)'/>

	</div>
</div>
</template>
<script>
import Detail from '@/Components/Pages/PageComponents/ProductDetail/Detail';
import Features from '@/Components/Pages/PageComponents/ProductDetail/Features';
import SelectedStore from '@/Components/Pages/PageComponents/ProductDetail/SelectedStore';
import TerpeneProfile from '@/Components/Pages/PageComponents/ProductDetail/Profile';
import Consumption from '@/Components/Pages/PageComponents/ProductDetail/Consumption';
// lets make a individual component, to less methods on this file
import MobileFooterActions from '@/Components/Pages/PageComponents/ProductDetail/MobileFooterActions';
import ProductDetailSkeleton from '@/Components/Pages/PageComponents/ProductDetail/Skeleton';
/**
 * Popups
 */
import ChangeStoreNotice from '@/Components/Pages/PageComponents/ProductDetail/ChangeStoreNotice';
import SelectStore from '@/Components/Pages/PageComponents/ProductDetail/SelectStore';
import OutOfStock from '@/Components/Pages/PageComponents/ProductDetail/OutOfStock';
import UserNotLoggedInModal from '@/Components/Pages/PageComponents/ProductDetail/UserNotLoggedInModal';
import CartApis from '@/Components/Controllers/CartApis';
import ProductApis from '@/Components/Controllers/ProductApis';
import LocationApis from '@/Components/Controllers/LocationApis';
import UserApis from '@/Components/Controllers/UserApis';
import VboutApis from '@/Components/Controllers/VboutApis';
import BusinerssProfileApis from '@/Components/Controllers/BusinerssProfileApis';

import Env from '@/env';
import { mapGetters, mapActions } from "vuex";
import { indexOf, find, isEmpty } from 'lodash';
// import ProductFavouriteApis from '@/Components/Controllers/ProductFavouriteApis';
import Helpers from '@/Components/Helpers/Helpers';

export default {
 components: {
    ProductDetailSkeleton,
    Detail,
    Features,
    TerpeneProfile,
    Consumption,
    SelectedStore,
 
    ChangeStoreNotice,
    SelectStore,
    OutOfStock,
    UserNotLoggedInModal,
    MobileFooterActions,
  },
  name: 'ProductDetail',
  data() {
    return {
      loaded: false,
      productDetail: {},
      outOfStock: false,
      favDetail: {},
    };
  },


  computed: {
    ...mapGetters({
      vg_guestLandedQueries: "location/guestLandedQueries",
      vg_selectedStore: "location/selected",
      vg_userId: "getLoggedInUserId",
      vg_storeProfileRecord: "storeprofile/storeProfileRecord",
    }),
  },

  watch: {
    '$route.params.product_id'() {
      this.refetchProduct()
    },
   'vg_userId'(val){
      if(val){
        Helpers.setPubNubUserLocationSubscribe({ 
          user_id: val, 
          location_id: this.vg_selectedStore.id
       });
      }
    },
  },

  created() {
    // if(this.vg_selectedStore.id) {
    //   this.va_setPastSelectedLocationId(this.vg_selectedStore.id);
    // }
    // this.va_setSelectedLocation({});
  },

  async mounted() {
    
    // let businessRes = await BusinerssProfileApis.fetchBusinessProfile(this.$route.params.business_slug);
    // if(businessRes.status != 200){
    //   // Its invalid business redirect to valid one
    //   this.va_snackbar({
    //     type: "warning",
    //     message: "Cannot find business."
    //   });
    //   return this.$router.push({ 
    //     name: 'HomePage', 
    //     params: {
    //       business_slug: Env.defaultBusinessSlug 
    //     },
    //     query: this.$route.query,
    //   });
    // }

    // let locationDetail = await LocationApis.fetchBySlug(this.$route.params.store_slug);
    // if(locationDetail.status != 200){
    //   this.va_snackbar({
    //     type: "warning",
    //     message:  "Cannot find the store."
    //   });
    //   return this.$router.push({ 
    //     name: 'HomePage',
    //     params: { 
    //       business_slug: this.$route.params.business_slug,
    //     },
    //     query: this.$route.query,
    //   })
    // }
    // this.va_setSelectedLocation(locationDetail.data.payload);



    // Fetch product detail
    let res = await ProductApis.fetchById(this.$route.params.product_id);
    if(res.status != 200){
      // if product doesnot exist back to Store profile route
      this.va_snackbar({
        type: "warning",
        message:  "Cannot find the product."
      });
      return this.$router.push({ 
        name: 'StoreProfile', 
        params: { 
          business_slug: this.$route.params.business_slug,
          store_slug: this.$route.params.store_slug
        },
        query: this.$route.query,
      })
    }
    
    if(this.$store.getters.getLoggedInUserId){
      await UserApis.fetchFavProducts();
      if(this.vg_selectedStore.id){
        UserApis.addUserLocation(this.$store.getters.getLoggedInUserId, this.vg_selectedStore.id, this.$route.query);
        setTimeout(()=> {
          Helpers.pubnubSubscribeAllChannels({ 
            user_id: this.$store.getters.getLoggedInUserId, 
            location_id: this.vg_selectedStore.id
          });
          Helpers.emitUserActivity();
        }, 1000)
      }
    }
    // Fetch cart in case of hard paste url
    CartApis.locationCart(this.vg_selectedStore.id, Helpers.getLocationCartFullUrl(this));

    this.productDetail = res.data.payload;
    this.loaded = true;
    // User might have hit direct link so let get location detail from given store_id
    
    // if(locationDetail.status == 200){
    //   // if the current selected location doesnot match with this product
    //  if(this.vg_selectedLocation.id != locationDetail.data.payload.id){
    //     // step 1 , set this location as active
    //     // step 2 , fetch cart for this location
    //  }
    // }
    
    if(this.$store.getters.getLoggedInUserToken){
      // lets save the data on vbout
      VboutApis.productView(this.productDetail, Helpers.getLocationProductFullUrl(this, this.productDetail.id), this.vg_selectedStore.id);
    } 

  },


  methods: {
    /**
     * Recommend product will need this 
     */
    async refetchProduct() {
       // Fetch product detail
      this.loaded = false;
      let res = await ProductApis.fetchById(this.$route.params.product_id);
      if(res.status != 200){
        // if product doesnot exist back to Store profile route
        this.va_snackbar({
          type: "warning",
          message:  "Cannot find the product."
        });
        return this.$router.push({ 
          name: 'StoreProfile', 
          params: { 
            business_slug: this.$route.params.business_slug,
            store_slug: this.$route.params.store_slug
          },
          query: this.$route.query,
        })
      }
    
      if(this.$store.getters.getLoggedInUserId){
        await UserApis.fetchFavProducts();
      }
      this.productDetail = res.data.payload;
      this.loaded = true;
      if(this.$store.getters.getLoggedInUserToken){
        // lets save the data on vbout
        VboutApis.productView(this.productDetail, Helpers.getLocationProductFullUrl(this, this.productDetail.id), this.vg_selectedStore.id);
      } 
    },

    goBack() {
      // Now while going back lets assign the location record, if has data then only insert for history
      if(this.vg_storeProfileRecord.data.length == 0) {
        // clear all filter on search
         this.va_resetFilters();
      }
      this.va_setStoreProfileRecord({
        insertHistory: this.vg_storeProfileRecord.data.length == 0 ? false : true,
      })

      window.history.length > 1 ? this.$router.go(-1) : this.$router.push({ name: 'HomePage' });
    },

    selectedLocationVariants(variants) {
      // First create unique variant and then on that variant add _is_stock_key
      let getUniqueProductVarinats = Helpers.getUniqueProductVariants(this.productDetail.product_family, variants);
      return Helpers.attachOutOfStockKey(getUniqueProductVarinats);
    },

    
    ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
      va_setSelectedLocation: "location/setSelected",
      va_setStoreProfileRecord: "storeprofile/setStoreProfileRecord",
      va_resetFilters: "searchproduct/setEmptySearchFilter",
      va_setPastSelectedLocationId: "location/setPastSelectedLocationId",
    })
  },
};
</script>
<style scoped>
.nab-bar-left {
  display: flex;
  flex-direction: row;
}
h1.title {
  margin-top: 9px;
}
.nav-bar-wrapper{
  display: flex;
  height: 100%;
}
.nab-bar-left{
  align-items: center;
}
</style>
